/**
 * Header component following Tenant Nexus UI style guide
 */

import React from 'react';
import { cn } from '@/utils';
import { UserProfile } from '@/components/UserProfile';

interface HeaderProps {
  className?: string;
  children?: React.ReactNode;
}

export function Header({ className, children }: HeaderProps) {
  return (
    <header className={cn('header-panel', className)}>
      <div className="header-logo">
        Tenant Nexus
      </div>
      <div className="flex items-center space-x-4">
        <UserProfile />
        {children}
      </div>
    </header>
  );
}
